var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pop-field',{attrs:{"label":_vm.label,"col":_vm.col}},[_c('text-align-picker',{attrs:{"value":_vm.value},on:{"input":function (v) { return _vm.$emit('input', v); },"change":function (v) { return _vm.$emit('change', v); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }